import * as React from 'react';
import { EPublishTermsStatus } from '../../types/reducers/publishTerms';
import { useSelector } from 'react-redux';
import { selectIsSubagentLimitExceed, selectPublishTermsStatus } from '../../selectors/publishTerms';
import { PromotionLayout } from './components/PromotionLayout';

export const PromotionContainer = () => {
  const status = useSelector(selectPublishTermsStatus);
  const isSubagentLimitExceed = useSelector(selectIsSubagentLimitExceed);

  const isLoading = status === EPublishTermsStatus.pending;
  const isError = status === EPublishTermsStatus.fail;

  if (isError || isSubagentLimitExceed) {
    return null;
  }

  return (
    <div data-testid="promotion">
      <PromotionLayout isLoading={isLoading} />
    </div>
  );
};
